import React from "react";
import { withRouter } from "../react/WithRouter";

import ExcelJS from "exceljs";
import saveAs from "file-saver";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';

import UserContext from '../../context/UserContext';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";


class AdmUsers extends React.Component {
	static contextType = UserContext;

	state = {
		isLoadingData: true,
		userList: [],
	};

	constructor(props) {
		super(props);
		//this.dataTableRef = React.createRef();

	}

	componentDidMount() {
		this.fetchControlList();
	}

	fetchControlList() {
		this.setState({ isLoadingData: true });
		
		fetch(`api/User/AllUsers`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				data.forEach(user => {
					user.lastLogin = new Date(user.lastLogin);
					user.created = new Date(user.created);
				})
				this.setState({ userList: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	dateBodyTemplate(date) {
		return date.toLocaleDateString('sv-SE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		});
	}

	render() {
		const leftTools = (
			<div style={{ textAlign: 'middle' }}>
				
			</div>
		);

		const rightTools = (
			<div>
				
			</div>
		);

		const toolbar = (
			<Toolbar className="mb-0" start={leftTools} end={rightTools}></Toolbar>
		);

		return (
			<div style={{ width: '100%', overflow: 'auto', height: '100%' }}>
					<DataTable
					loading={this.state.isLoadingData}
					ref={this.dataTableRef}
					value={this.state.userList}
					tableStyle={{ minWidth: '50rem', width: '100%' }}
					size="small"
					removableSort
					header={toolbar}
					scrollable
					scrollHeight="flex"
					resizableColumns showGridlines
					emptyMessage="No users found."
					selectionMode="single"
					
				>
					< Column
						field="userID"
						header="UserID"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem' }}
					>
					</Column>
					< Column
						field="fullName"
						header="Name"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '7rem', minWidth: '11rem' }}							
					>
					</Column>
					< Column
						field="email"
						header="Email"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '11rem' }}
					>
					</Column>
					< Column
						field="admin"
						header="Admin"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem' }}
					>
					</Column>
					< Column
						field="sysAdmin"
						header="SysAdmin"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem' }}
					>
					</Column>
					< Column
						field="verified"
						header="Verified"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem' }}
					>
					</Column>
					< Column
						field="active"
						header="Active"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem' }}
					>
					</Column>
					< Column
						field="lastLogin"
						header="Last login"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '7rem', minWidth: '11rem' }}
						dataType="date"
						body={(rowData)=> this.dateBodyTemplate(rowData.lastLogin)}
					>
					</Column>
					< Column
						field="created"
						header="Created"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '7rem', minWidth: '11rem' }}
						dataType="date"
						body={(rowData) => this.dateBodyTemplate(rowData.created)}
					>
					</Column>
					
				</DataTable>
			</div>
		);
	}
}
/*

					*/
export default withRouter(AdmUsers);